var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.shoudlBuildReadOnlyAlert()
    ? _c(
        "div",
        [
          _c("emd-alert", {
            staticClass: "eu-mt_0 eu-no-mb eu-mt_5",
            attrs: {
              variant: "info",
              noClose: "",
              title: _vm.$t(this.buildText()),
              autoclose: false,
              "data-testid": "emd-alert",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }